import type { DocumentTemplate } from "@models";

/**
 * Prepares the backend-resolved template list for the Frames view: drops
 * deprecated templates (their replacement is listed instead), applies the
 * search, and sorts by title. Hierarchy resolution and hidden filtering
 * happen on the backend.
 */
export const filterFrameTemplates = (
  templates: DocumentTemplate[],
  search: string
): DocumentTemplate[] => {
  const query = search.trim().toLowerCase();

  return templates
    .filter(
      (template) =>
        !template.deprecatedByTemplateKey &&
        (!query ||
          template.defaultTitle.toLowerCase().includes(query) ||
          template.templateKey.toLowerCase().includes(query))
    )
    .sort((a, b) => a.defaultTitle.localeCompare(b.defaultTitle));
};
